<template>
  <Content @content-loaded="setBreadcrumb" />
</template>

<script>
import Content from "@/gapp-components/components/common/content/Content.vue";

export default {
  name: "ContentPage",
  components: {
    Content
  },
  metaInfo: {
    title: "Content"
  },
  methods: {
    setBreadcrumb({ contentKey, isNew }) {
      this.$store.dispatch("setBreadcrumb", [
        {
          text: this.$i18n.translate("Dashboard"),
          to: { name: "dashboard" },
          exact: true
        },
        {
          text: "Admin"
        },
        {
          text: this.$i18n.translate("Contents"),
          to: { name: "contents" },
          exact: true
        },
        {
          text: isNew ? "New Content" : contentKey
        }
      ]);
    }
  }
};
</script>
